/** Inline stylesheet for the exported index.html. No external fonts or images. */
export const VIEWER_CSS = `
*{box-sizing:border-box}
[hidden]{display:none!important}
body{margin:0;background:#0f172a;color:#e2e8f0;font:16px/1.4 -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif}
header{padding:24px 20px 8px}
h1{margin:0;font-size:24px}
.meta{margin:6px 0 0;color:#94a3b8;font-size:14px}
.empty{padding:40px 20px;color:#94a3b8}
.grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(150px,1fr));gap:6px;padding:12px 20px 40px}
.tile{position:relative;aspect-ratio:1;padding:0;border:0;border-radius:6px;overflow:hidden;background:#1e293b;cursor:pointer}
.tile img{width:100%;height:100%;object-fit:cover;display:block}
.ph{display:flex;align-items:center;justify-content:center;width:100%;height:100%;color:#64748b;font-size:32px}
.badge{position:absolute;right:6px;bottom:6px;padding:2px 7px;border-radius:10px;background:rgba(0,0,0,.6);color:#fff;font-size:12px}
#box{position:fixed;inset:0;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,.94)}
#stage{display:flex;align-items:center;justify-content:center;max-width:92vw;max-height:84vh}
#stage img,#stage video{max-width:92vw;max-height:84vh}
.nav{position:fixed;top:50%;transform:translateY(-50%);padding:14px 18px;border:0;border-radius:50%;background:rgba(255,255,255,.12);color:#fff;font-size:22px;cursor:pointer}
#prev{left:16px}#next{right:16px}
#close{position:fixed;top:16px;right:16px;padding:8px 14px;border:0;border-radius:20px;background:rgba(255,255,255,.12);color:#fff;font-size:16px;cursor:pointer}
#open{position:fixed;bottom:20px;left:50%;transform:translateX(-50%);padding:10px 18px;border-radius:8px;background:#fff;color:#0f172a;text-decoration:none;font-weight:600}
`;

/** Inline viewer script. Reads everything it needs from each tile's data- attributes. */
export const VIEWER_JS = `
(function(){
var tiles=[].slice.call(document.querySelectorAll('.tile'));
var box=document.getElementById('box'),stage=document.getElementById('stage'),open=document.getElementById('open'),cur=-1;
function fallback(thumb){stage.innerHTML='';if(thumb){var p=document.createElement('img');p.src=thumb;stage.appendChild(p);}open.hidden=false;}
function show(i){
  if(i<0||i>=tiles.length)return;
  cur=i;var t=tiles[i],src=t.getAttribute('data-src'),thumb=t.getAttribute('data-thumb'),type=t.getAttribute('data-type');
  stage.innerHTML='';open.href=src;open.hidden=true;
  if(type==='video'){var v=document.createElement('video');v.controls=true;v.autoplay=true;v.onerror=function(){fallback(thumb)};v.src=src;stage.appendChild(v);}
  else if(type==='photo'){var im=document.createElement('img');im.onerror=function(){fallback(thumb)};im.src=src;stage.appendChild(im);}
  else{fallback(thumb);}
  box.hidden=false;
}
function close(){box.hidden=true;stage.innerHTML='';cur=-1;}
tiles.forEach(function(t,i){t.addEventListener('click',function(){show(i)})});
document.getElementById('prev').addEventListener('click',function(){show(cur-1)});
document.getElementById('next').addEventListener('click',function(){show(cur+1)});
document.getElementById('close').addEventListener('click',close);
box.addEventListener('click',function(e){if(e.target===box)close()});
document.addEventListener('keydown',function(e){
  if(box.hidden)return;
  if(e.key==='Escape')close();
  if(e.target&&e.target.tagName==='VIDEO')return;
  if(e.key==='ArrowLeft')show(cur-1);
  if(e.key==='ArrowRight')show(cur+1);
});
})();
`;
